import { Copy } from "./icons-DDR9dFSr.js";
import { Button, ButtonInline } from "./Button-i0ITjN_1.js";
import { Clipboard } from "./Clipboard-B2isZvt_.js";
import { jsx, jsxs } from "react/jsx-runtime";
// src/blocks/ClipboardButton/ClipboardButton.tsx
const DEFAULT_ICON = /* @__PURE__ */ jsx(Copy, {});
const DEFAULT_ARIA_LABEL = "Copy";
const ClipboardButton = ({ text, tooltip, tooltipPlacement, tooltipVariant, icon = DEFAULT_ICON, variant = "outline", children, ...rest }) => {
	const defaultAriaLabel = typeof tooltip === "string" && tooltip.trim() ? tooltip : DEFAULT_ARIA_LABEL;
	const ariaLabel = rest["aria-label"] ?? (children == null ? defaultAriaLabel : void 0);
	return /* @__PURE__ */ jsx(Clipboard, {
		asChild: true,
		tooltip,
		tooltipPlacement,
		tooltipVariant,
		text,
		children: /* @__PURE__ */ jsxs(Button, {
			...rest,
			"aria-label": ariaLabel,
			variant,
			disabled: !text,
			children: [icon, children]
		})
	});
};
// src/blocks/ClipboardButton/ClipboardInline.tsx
const ClipboardInline = ({ text, tooltip, tooltipPlacement, tooltipVariant, children = "Copy To Clipboard", hideIcon = false, ...rest }) => /* @__PURE__ */ jsx(Clipboard, {
	asChild: true,
	text,
	tooltip,
	tooltipPlacement,
	tooltipVariant,
	children: /* @__PURE__ */ jsxs(ButtonInline, {
		...rest,
		disabled: !text,
		children: [!hideIcon && /* @__PURE__ */ jsx(Copy, { className: "tw:size-4" }), children]
	})
});
export { ClipboardButton, ClipboardInline };

//# sourceMappingURL=ClipboardButton-BORhLECc.js.map